import { Box, Button, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import CustomCard from "../../components/CustomCard";
import Loader from "../../components/Loader";
import useDisabledOnLoading from "../../hooks/useDisabledOnLoading";
import { firestore } from "../../init/firebase";
import { GenericObject } from "../../types/generic.types";
import { AppResource } from "../../types/resource.types";
import { injectMetadataToSnapshotData } from "../../utils/firebase";
import ReservationsStatusText from "./components/ReservationsStatusText";
import { qar } from "../../utils/generic";
import EntertainmentName from "./components/EntertainmentName";
import ClientName from "../../components/ClientData/components/ClientName";
import RequestDateStatus from "../EntertainmentsVendors/Requests/components/RequestDateStatus";
import SectionTitle from "./components/SectionTitle";

const AdventureRequests = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [disabledLoading, setDisabledLoading] = useState(false);
  const { disabledStyles } = useDisabledOnLoading(disabledLoading);

  const fetchData = async () => {
    setLoading(true);
    try {
      const snapshots = await firestore
        .collectionGroup(AppResource.entertainmentRequests)
        .where("status", "in", ["confirmed", "canceled"])
        .where("type", "==", "adventure")
        .orderBy("createdAt", "desc")
        .limit(20)
        .get();
      if (!snapshots.empty) {
        const data = snapshots.docs.map((doc) => injectMetadataToSnapshotData(doc));
        setData(data);
      }
      setLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setLoading(false);
    }
  };

  const onLoadMore = async () => {
    setDisabledLoading(true);
    try {
      const lastSnapshot = data[data.length - 1];
      const snapshots = await firestore
        .collectionGroup(AppResource.entertainmentRequests)
        .where("status", "in", ["confirmed", "canceled"])
        .where("type", "==", "adventure")
        .orderBy("createdAt", "desc")
        .startAfter(lastSnapshot.snapshot)
        .limit(20)
        .get();
      if (!snapshots.empty) {
        const data = snapshots.docs.map((doc) => injectMetadataToSnapshotData(doc));
        setData((prevData: any) => [...prevData, ...data]);
      }
      setDisabledLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setDisabledLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box style={disabledStyles}>
      <Loader loading={loading}>
        {data.length ? (
          <Box>
            <SectionTitle title="Adventure Requests" />
            <Box
              style={{
                backgroundColor: "#fff",
                padding: "10px 15px",
                marginBottom: 20,
                boxShadow: `0px 2px 3px #bdbdbd`,
                borderRadius: 6,
              }}
            >
              <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography style={{ width: 150 }}>Client</Typography>
                <Typography style={{ width: 150 }}>Vendor</Typography>
                <Typography style={{ width: 100 }}>Service Name</Typography>
                <Typography style={{ width: 70 }}>Price</Typography>
                <Typography style={{ width: 70 }}>Payment Method</Typography>

                <Typography style={{ width: 100 }}>Date</Typography>
                <Typography style={{ width: 100 }}>Changed Time Status</Typography>
                <Typography style={{ width: 100 }}>Created At</Typography>
                <Typography style={{ width: 70 }}>Status</Typography>
              </Box>
            </Box>
            {data.map((record: GenericObject) => {
              return (
                <Box
                  key={record.id}
                  style={{
                    backgroundColor: "#fff",
                    padding: "10px 15px",
                    marginBottom: 10,
                    boxShadow: `0px 2px 3px #bdbdbd`,
                    borderRadius: 6,
                  }}
                >
                  <Box style={{ display: "flex", justifyContent: "space-between" }}>
                    <Box style={{ width: 150 }}>
                      <ClientName record={record} />
                    </Box>

                    <EntertainmentName id={record.vendorId} />
                    <Typography style={{ width: 100 }} color="textSecondary">
                      {record.service.name.en}
                    </Typography>

                    <Typography style={{ width: 70 }} color="textSecondary">
                      {qar(record.service.price)}
                    </Typography>
                    <Typography style={{ width: 70 }} color="textSecondary">
                      {record.paymentMethod}
                    </Typography>

                    <Typography style={{ width: 100 }} color="textSecondary">
                      {dayjs(record.date.toDate()).format("DD/MM/YYYY")}
                    </Typography>

                    <Box style={{ width: 100 }}>
                      <RequestDateStatus record={record} />
                    </Box>

                    <Typography style={{ width: 100 }} color="textSecondary">
                      {dayjs(record.createdAt.toDate()).format("DD/MM/YYYY - hh:mm a")}
                    </Typography>
                    <ReservationsStatusText record={record} />
                  </Box>
                </Box>
              );
            })}

            <Box style={{ textAlign: "center" }}>
              <Button variant="contained" color="secondary" onClick={onLoadMore}>
                Load More
              </Button>
            </Box>
          </Box>
        ) : (
          <CustomCard width="50%">
            <Typography>No Requests yet!</Typography>
          </CustomCard>
        )}
      </Loader>
    </Box>
  );
};

export default AdventureRequests;
